export const fetchSurveyListsStart = (state, payload) => {
    return {
        ...state,
        fetchSurveyLists: {
            ...state.fetchSurveyLists,
            isProcessing: true,
            error: false,
        }


    };
};

export const fetchSurveyListsSuccess = (state, payload) => {
    return {
        ...state,
        benchmarkFiltersAnalysis: {
            ...state.benchmarkFiltersAnalysis,
            surveys: payload.data && payload.data.data ? payload.data.data.value : [],

        },
        benchmarkFilters: {
            ...state.benchmarkFilters,
            surveys: payload.data && payload.data.data ? payload.data.data.value : [],

        },
        fetchSurveyLists: {
            ...state.fetchSurveyLists,
            isProcessing: false,
            error: false,
            data: payload.data && payload.data.data ? payload.data.data : null
        },
        isSurveyListFetched: true

    };
};

export const fetchSurveyListsFail = (state, payload) => {
    return {
        ...state,
        fetchSurveyLists: {
            ...state.fetchSurveyLists,
            isProcessing: false,
            error: true,
            data: null
        },
        isSurveyListFetched: false

    };
};
